import { CONTENT } from "@bitComponents/unifiedComponents/Stopper";
import { USER_TYPE } from "../../../../bitConstants/constants";
import {
  CALL_GENERIC_900,
  PACK_BUTTONS,
  PHONE_900,
  PHONE_900_OPERATION_NOT_AUTHORIZED,
} from "../../errorTextsConstants";

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      BLOCKED_BY_NETFLIX: { // TODO revisar en desuso
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "No es posible generar tu pedido automáticamente",
          msg: [
            'Tras revisar tu configuración no podemos realizar el cambio solicitado automáticamente.',
            `Llámanos gratis al ${PHONE_900} y un asesor comercial se encargará de resolverlo.`,
            'Sentimos las molestias ocasionadas.',
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "producto incompatible por netflix en parque",
        },
      },
      INCOMPATIBLE_PRODUCT_BY_ZONE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Sentimos las molestias",
          msg: [
            "La dirección de instalación no pertenece al código postal de las ofertas mostradas en el configurador de miMovistar.",
            `Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a resolver el problema.`
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "producto incompatible con zona",
        },
      },
      PRODUCT_REGISTERED: {
        errorInfo: {
          buttons: [PACK_BUTTONS.seeOtherPackConfigProducts],
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorInfo: {
          title: "Producto incompatible",
          msg: [
            "El producto seleccionado es incompatible con tu producto actual.",
          ],
          buttons: [PACK_BUTTONS.seeOtherPackConfigProducts],
        },
      },
      CLIENT_WITH_RISK: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            PACK_BUTTONS.goBackPackConfig,
            PACK_BUTTONS.callPhoneOperationNotAuthorized,
          ],
          title: "Pedido no realizado",
          msg: [
            "Tras validar tus datos no es posible generar tu pedido automáticamente.",
            "Si estabas incluyendo un dispositivo en el pedido puedes cambiar el dispositivo elegido por uno sin coste o eliminarlo en el configurador.",
            `También puedes ponerte en contacto con un asesor comercial llamando gratis al ${PHONE_900_OPERATION_NOT_AUTHORIZED} para que te ayude con la realización del pedido.`,
          ],
          errorName: "Operación no autorizada",
        },
      },
      ACCOUNT_WITH_RISK: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "No es posible generar tu pedido automáticamente",
          msg: [
            `Tras validar tus datos no es posible seguir con el pedido en curso, para solucionarlo es
            necesario que te pongas en contacto con nosotros llamando gratis al ${PHONE_900_OPERATION_NOT_AUTHORIZED}`,
          ],
          buttons: [PACK_BUTTONS.callPhoneOperationNotAuthorized],

          errorName: "Cuenta con riesgo",
        },
      },
      SPEED_UNAVAILABLE: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Estás solicitando una de velocidad que no tienes disponible',
          msg: [`Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a resolver el problema.`],
          buttons: [CALL_GENERIC_900],
          errorName: 'velocidad no disponible',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Upss… algo ha ido mal",
          msg: [
            "Se ha producido un error al generar tu pedido.",
            `Por favor, reinténtalo más tarde o llámanos gratis al ${PHONE_900} para que podamos gestionarlo.`,
            "Sentimos las molestias.",
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "error generico",
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {},
    [`user_${USER_TYPE.OPEN}`]: {},
  }
};
